export const CONTENT_PADDING_X = { lg: 123, md: 88, base: 30 };
